import type { DistributorSettingsParams, DistributorsSettingsParams } from '@/api/domains/settings.api';
import { paramsToQueryKey } from '@/shared/lib/react-query';

const PREFIX = 'settings';

export const SettingsQueryKeys = {
  root: [PREFIX],

  distributorsSettings: (params?: DistributorsSettingsParams) =>
    paramsToQueryKey([PREFIX, 'distributors-settings'], params),

  distributorSettings: (params: Partial<DistributorSettingsParams>) =>
    paramsToQueryKey([PREFIX, 'distributor-settings'], params),

  searchSettings: [PREFIX, 'search-settings'],
  paymentTypesSettings: [PREFIX, 'payment-types-settings'],

  drugExpiryDateSettingsKey: [PREFIX, 'drug-expiry-date-settings'],
} as const;
